import { AuthService } from "./auth.service";
import axios from "axios";
import { ApiRootConstants } from "../_constants/index";

var Constants = {
  OccupancyIndicatorApiRoot: ApiRootConstants.OccupancyIndicatorApiRoot
};

const authService = new AuthService();

export async function getMonitorAlertSettings(venueId) {
  const user = await authService.getUser();
  if (user && user.access_token) {
    const options = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + user.access_token,
      },
    };
    return await axios
      .get(`${Constants.OccupancyIndicatorApiRoot}api/MonitorAlertSetting?venueId=${venueId}`,
        options
      )
      .catch((error) => {
        console.error(error);
        if (error.response) {
          if (error.response.status === 401) {
            throw new Error("User is not logged in");
          } else if (error.response.status === 422) {
            throw new Error(error.response.data.message);
          }
        }

        throw error;
      });
  }
}

export async function setMonitorAlertSettings(monitorAlertSetting) {
  const user = await authService.getUser();
  if (user && user.access_token) {
    const options = {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + user.access_token,
      },
    }; 

    return await axios
      .post(
        Constants.OccupancyIndicatorApiRoot + "api/MonitorAlertSetting",
        monitorAlertSetting,
        options
      )
      .catch((error) => {
        console.error(error);
        if (error.response) {
          if (error.response.status === 401) {
            throw new Error("User is not logged in");
          } else if (error.response.status === 422) {
            throw new Error(error.response.data.message);
          }
        }

        throw error;
      });
  }
}
